import { render, staticRenderFns } from "./MtReceiptDetail.vue?vue&type=template&id=0b5bfd82&"
import script from "./MtReceiptDetail.vue?vue&type=script&lang=js&"
export * from "./MtReceiptDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports